/* eslint-disable consistent-return */
import React, { useState } from 'react';
import { useMetaMask } from 'metamask-react';
import {
  AddMemberForm, Feedbacktext, InfoText, InputLabel,
  InputWrapper, PopupInput, UpdateButton,
} from './addWalletElements';
import useAxiosPrivate from '../../../Hooks/useAxiosPrivate';
import useAuth from '../../../Hooks/useAuth';

const AddMemberPopup = ({ setOpen }) => {
  const axiosPrivate = useAxiosPrivate();
  const { setAuth, auth } = useAuth();
  const { connect, account } = useMetaMask();

  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!account) {
      return setFeedback('Wallet empty');
    }

    if (account === auth.wallet) {
      return setFeedback('Wallet address is same');
    }

    setLoading(true);

    axiosPrivate.post(
      '/addWallet',
      JSON.stringify({
        memberWallet: account,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status === 'error') {
        setLoading(false);
        setFeedback(res.data.message ? res.data.message : 'Something went wrong');
      } else {
        setFeedback(res.data.message);
        setAuth((prev) => ({
          ...prev,
          wallet: account,
        }));
        setTimeout(() => {
          setLoading(false);
          setOpen(false);
          setFeedback('');
        }, 1000);
      }
    }).catch((error) => {
      setLoading(false);
      setFeedback(error.response.data.message ? error.response.data.message : 'Something went wrong');
    });
  };

  return (
    <AddMemberForm onSubmit={handleSubmit}>
      <InputWrapper>
        <InputLabel htmlFor="wallet">{account ? 'Wallet:' : 'Existing wallet:'}</InputLabel>
        <PopupInput
          value={account || auth.wallet}
          autoComplete="off"
          aria-describedby="uidnote"
          type="text"
          name="wallet"
          disabled
        />
      </InputWrapper>
      <InputWrapper>
        <InfoText>
          This will not create a transaction. It will only add your wallet to your account.
          Wallet can be changed later on.
        </InfoText>
      </InputWrapper>
      {!account && <UpdateButton onClick={connect} type="button">{auth.wallet ? 'Connect new wallet' : 'Connect'}</UpdateButton>}
      {account && <UpdateButton disabled={loading} type="submit">{loading ? 'Adding wallet' : 'Add wallet'}</UpdateButton>}
      {feedback && <Feedbacktext>{feedback}</Feedbacktext>}
    </AddMemberForm>
  );
};

export default AddMemberPopup;
